import { GROUP_ORDER, type CreateMenuItem, type CreateGroup } from './createRegistry'

export interface CreateMenuGroup {
  group: CreateGroup
  items: CreateMenuItem[]
}

/**
 * 按权限过滤创建项并分组；整组无可见项则该组不返回（空组隐藏）。
 * 这是 UX advisory 门，真正拦截在后端。
 */
export function filterCreateItems(
  items: CreateMenuItem[],
  hasPermission: (code: string) => boolean,
): CreateMenuGroup[] {
  return GROUP_ORDER.map((group) => ({
    group,
    items: items.filter((item) => item.group === group && hasPermission(item.perm)),
  })).filter((g) => g.items.length > 0)
}
